import { Button, Space, Table } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";

import { memo } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { PATH_HEALTH_RECORDS } from "@configs";
import { EditOutlined } from "@ant-design/icons";
import { IHealthRecord } from "@interfaces";

interface IProps {
  data: IHealthRecord[];
}
export const HealthTable = memo(({ data }: IProps) => {
  const { t } = useTranslation();
  const dataSource: IHealthRecord[] = data;
  const columns: ColumnsType<IHealthRecord> = [
    {
      title: t("page.clinic_name"),
      dataIndex: "clinic_name",
      key: "1",
      width: 150,
      fixed: 'left',      
    },
    {
      title: t("page.client_Name"),
      dataIndex: "client_name",
      key: "1",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.client_age"),
      dataIndex: "client_age",
      key: "2",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.clinic_visit_date"),
      dataIndex: "client_visit_date",
      key: "3",
      width: 150,
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : t("page.empty")),
    },
    {
      title: t("page.township"),
      dataIndex: "client_township_name",
      key: "4",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.state"),
      dataIndex: "client_region_name",
      key: "5",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Ph_Number"),
      dataIndex: "client_phoneNumber",
      key: "6",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Gender"),
      dataIndex: "client_gender",
      key: "7",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Parity"),
      dataIndex: 'birth_spacing_parity',
      key: "8",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Occasion"),
      dataIndex: "birth_spacing_occasion",
      key: "9",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.User"),
      dataIndex: "birth_spacing_user_type",
      key: "10",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Birth_Spacing_Method"),
      dataIndex: "birth_spacing_main_method_for_now",
      key: "11",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Insertion"),
      dataIndex: "birth_spacing_insertion",
      key: "12",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.CCP_awareness"),
      dataIndex: "ccp_awareness",
      key: "13",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.CCP_Screening"),
      dataIndex: "ccp_screening",
      key: "14",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.CCP_Treatment"),
      dataIndex: "ccp_treatment",
      key: "15",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.AYFHS_STI"),
      dataIndex: "ayfhs_sti",
      key: "16",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.AYFHS_Birth_Spacing"),
      dataIndex: "ayfhs_birth_spacing",
      key: "17",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.AYFHS_RH_Problems"),
      dataIndex: "ayfhs_rh_problem",
      key: "18",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.GVB_Awareness"),
      dataIndex: "gbv_awareness",
      key: "19",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.GVB_Hotline"),
      dataIndex: "gbv_hotline",
      key: "20",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Disability"),
      dataIndex: "disability",
      key: "21",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Seeing"),
      dataIndex: "seeing_disability",
      key: "22",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Difficulty_Level"),
      dataIndex: "seeing_disability_level",
      key: "23",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Hearing"),
      dataIndex: "hearing_disability",
      key: "24",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Difficulty_Level"),
      dataIndex: "hearing_disability_level",
      key: "25",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Walking"),
      dataIndex: "walking_disability",
      key: "26",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Difficulty_Level"),
      dataIndex: "walking_disability_level",
      key: "27",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Concentration"),
      dataIndex: "concentration_disability",
      key: "28",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Difficulty_Level"),
      dataIndex: "concentration_disability_level",
      key: "29",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Self_Care"),
      dataIndex: "self_care_disability",
      key: "30",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Difficulty_Level"),
      dataIndex: "self_care_disability_level",
      key: "31",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Communication"),
      dataIndex: "communication_disability",
      key: "32",
      width: 150,
      render:(value)=> (value ? value : "---")
    },
    {
      title: t("page.Difficulty_Level"),
      dataIndex: "communication_disability_level",
      key: "33",
      width: 150,
      render:(value)=> (value ? value : "---")
    },        
    {
      title: t("page.actions"),
      key: "34",
      fixed: 'right',
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Space>
            <Link
              to={PATH_HEALTH_RECORDS + `/${record?._id}`}
            >
              <Button type="ghost" icon={<EditOutlined />} size={"small"} />
              <span>{t("page.edit")}</span>
            </Link>
          </Space>
        </Space>
      ),
    },
  ];

  return <Table dataSource={dataSource} rowKey={"userId"} columns={columns} pagination={false} scroll={{ x: 200, y: "auto" }}/>;
});
